// src/theme/messageStyles.ts
export const MESSAGE_CLASS_NAMES = {
    error: 'bg-[#fee2e2] text-[#991b1b] p-3 rounded-lg text-sm mb-4',
    warning: 'bg-[#fef9c3] text-[#854d0e] p-3 rounded-lg text-sm mb-4',
    info: 'bg-[#dbeafe] text-[#1e40af] p-3 rounded-lg text-sm mb-4',
    success: 'bg-[#dcfce7] text-[#166534] p-3 rounded-lg text-sm mb-4',
    debug: 'bg-yellow-100 text-yellow-800 p-3 rounded-lg text-sm mb-4 overflow-auto max-h-60',
  };
  
  export const AUTH_CLASS_NAMES = {
    formContainer: 'space-y-6',
    formGroup: 'space-y-1 mb-4',
    label: 'block text-sm font-medium text-[#465357]',
    input: 'w-full rounded-lg border border-[#A7ABAA] px-4 py-2 focus:ring-2 focus:ring-[#245D33] focus:border-transparent',
    
    checkboxContainer: 'flex items-center',
    checkboxInput: 'h-4 w-4 rounded border-gray-300 text-[#245D33] focus:ring-[#245D33]',
    checkboxLabel: 'ml-2 block text-sm text-[#465357]',
    
    dividerContainer: 'relative my-6',
    dividerLine: 'absolute inset-0 flex items-center',
    dividerLineInner: 'w-full border-t border-gray-300',
    dividerTextContainer: 'relative flex justify-center text-sm',
    dividerText: 'px-2 bg-white text-[#A7ABAA]',
  };